import { Breadcrumbs } from '@components/shared/breadcrumbs.component';
import { SurveyHeader } from '@components/shared/survey-header.component';

type AssessmentQuestionShellProps = {
  children: React.ReactNode;
  currentQuestionIndex?: number;
  headerItems: { href?: string; label: string }[];
  onSlotClick?: (index: number) => void;
  progress: number;
  questionLabels?: { isComplete: boolean; label?: string }[];
  sectionIndex: number;
  sectionTitle: string;
};

export const AssessmentQuestionShell: React.FC<AssessmentQuestionShellProps> = (props) => {
  const {
    children,
    currentQuestionIndex,
    headerItems,
    onSlotClick,
    progress,
    questionLabels,
    sectionIndex,
    sectionTitle,
  } = props;

  return (
    <div className="@container/question-route flex w-full flex-col items-center py-6">
      <div className="w-full px-3 @min-[42rem]/question-route:px-6">
        <SurveyHeader
          currentQuestionIndex={currentQuestionIndex}
          header={<Breadcrumbs items={headerItems} />}
          onSlotClick={onSlotClick}
          progress={progress}
          slots={questionLabels}
          title={sectionTitle}
          value={sectionIndex + 1}
        />
        <div className="mt-3 rounded-xl bg-white">{children}</div>
      </div>
    </div>
  );
};
